<template>
    <BreadCrumb PageTitle="Integration List" />
    <IntegrationList />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import IntegrationList from "../../components/Integrations/IntegrationList.vue";
  
  export default defineComponent({
    name: "IntegrationsPage",
    components: {
      BreadCrumb,
      IntegrationList,
    },
  });
  </script>